import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { TextField, Menu, Box, InputAdornment } from "@mui/material";
import { TreeInput } from "@react-admin/ra-tree";
const TreeSelect = ({ label, source, open, anchorEl, setAnchorEl, handleSelect, data, displayValues }) => {
  return (
    <>
      <TextField
        fullWidth
        label={label}
        value={displayValues || ""}
        onClick={e => setAnchorEl(e.currentTarget)}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon
                sx={{
                  transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: open ? "rotate(180deg)" : "rotate(0deg)",
                  transformOrigin: "center",
                }}
              />
            </InputAdornment>
          ),
        }}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            maxHeight: 350,
            minWidth: "35%",
            overflowY: "auto",
            p: 1,
          },
        }}
      >
        <Box sx={{ width: "98%" }}>
          <TreeInput
            defaultExpandAll
            sx={{
              width: "100%",
              "& .rc-tree-treenode .rc-tree-node-selected": {
                borderBottom: ".5px solid rgb(0 0 0 / 25%)",
                backgroundColor: "#6a26c814",
              },
              "& .rc-tree-title:hover": { backgroundColor: "#41148014" },
              "& .rc-tree-treenode .rc-tree-node-selected:hover": { backgroundColor: "#6a26c814" },
            }}
            source={source}
            data={data}
            label={false}
            multiple={false}
            onChange={handleSelect}
          />
        </Box>
      </Menu>
    </>
  );
};

export default TreeSelect;
